module.exports = __webpack_public_path__ + "img/square-dark-colored.ed22aa6.svg";